import { render, staticRenderFns } from "./KeyboardTest.vue?vue&type=template&id=fc58e138&scoped=true&"
import script from "./KeyboardTest.vue?vue&type=script&lang=js&"
export * from "./KeyboardTest.vue?vue&type=script&lang=js&"
import style0 from "./KeyboardTest.vue?vue&type=style&index=0&id=fc58e138&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc58e138",
  null
  
)

export default component.exports